import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useId } from 'react';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import styles from './Pagination.styles.esm.js';
import { PaginationBody } from './PaginationBody.esm.js';
import { PaginationButton } from './PaginationButton.esm.js';

/**
 * Pagination component provides navigation controls for paginated content.
 * Built on Radix UI primitives for accessibility and customization.
 */
const Pagination = (props) => {
    const generatedId = useId();
    const { id = generatedId, currentPage = 1, className, totalPages, inverse, buildHref, onPageChange } = props, otherProps = __rest(props, ["id", "currentPage", "className", "totalPages", "inverse", "buildHref", "onPageChange"]);
    const { root: rootClasses, list: listClasses } = styles({ inverse });
    return (jsx(NavigationMenu.Root, Object.assign({ id: id, className: rootClasses({ class: className }), "aria-label": "Pagination", value: "root" }, otherProps, { "data-orientation": undefined, children: jsxs(NavigationMenu.List, { className: listClasses(), "data-orientation": undefined, children: [jsx(PaginationButton, { direction: "previous", currentPage: currentPage, totalPages: totalPages, buildHref: buildHref, inverse: inverse, onClick: onPageChange }), jsx(PaginationBody, { totalPages: totalPages, currentPage: currentPage, onPageChange: onPageChange, buildHref: buildHref, inverse: inverse }), jsx(PaginationButton, { direction: "next", currentPage: currentPage, totalPages: totalPages, buildHref: buildHref, inverse: inverse, onClick: onPageChange })] }) })));
};
Pagination.displayName = "Pagination";

export { Pagination };
